export default __webpack_public_path__ + "static/media/bird5.e74c7287.svg";